// extracted by mini-css-extract-plugin
export default {"tupacGrid":"_m-z","tupacHeader":"an-z","tupacHeader2":"bn-z","tupacMenu":"cn-z","tupacMenu2":"dn-z","tupacMain":"en-z","tupacMain2":"fn-z"};